import projectImage1 from "../assets/studybhai.PNG"
import projectImage2 from "../assets/insurecow.PNG"
import projectImage4 from "../assets/covid.png"
import laracms from "../assets/lara-cms.png"
import arannayk from '../assets/arannayk.jpg'

export const projects = [
    {
        id: 0,
        featured: false,
        name: 'Laravel CMS',
        category: 'Laravel',
        liveURL: 'https://github.com/stmeem/laravel-cms',
        cover: laracms,
    },
    {
        id: 1,
        featured: true,
        name: 'InsureCow',
        category: 'Bootstrap',
        liveURL: 'http://insurecow.com/',
        cover: projectImage2,
        overview: 'InsureCow offers a technology-powered cattle insurance and wellbeing monitoring platform. It create a digital and robust bridge between farmers, NGOs, Insurers, and financial institutions.'
    },
    {
        id: 2,
        featured: true,
        name: 'Arannayk',
        category: 'Laravel',
        liveURL: 'https://arannayk.org/',
        cover: arannayk,
        overview: "Arannayk Foundation protects, restores, and sustainably uses Bangladesh's tropical forests. It helps organizations conserve forests and biodiversity"
    },
    {
        id: 3,
        featured: false,
        name: 'StudyBhai',
        category: 'Bootstrap',
        liveURL: 'https://github.com/sumaiyaa-t/studybhai',
        cover: projectImage1,
        overview: 'StudyBhai is an e learning platform which focuses on blended learning aspects for its students and to revolutionize blended learning in Bangladesh'
    },
    {
        id: 4,
        featured: false,
        name: 'COVID-19 Tracker Website',
        category: 'Python',
        liveURL: 'https://github.com/stmeem/covid19-map',
        cover: projectImage4,
        overview: 'A webmap using python libraries to visualize covid-19 data. The data is collected from Johns Hopkins data repository. Zoom in the map and click on the markers to get the data of any country.'
    },
   ]